import React, { Component } from 'react'
import { connect } from 'react-redux'
import {signOutUser} from "../../api/auth";

class SideBarMenuBottom extends Component {
	constructor(props) {
		super(props);
	}
	
	componentWillMount() {
	
	}
	
	componentDidMount() {
	
	}

	reload() {
		window.location.reload(true);
	}

	render() {
		return (
			<div className={'sidebar__menu__bottom'}>
				<ul>
					<li><button onClick={signOutUser}><i className="fa fa-sign-out"></i></button></li>
					<li><button onClick={this.reload}><i className="fa fa-refresh"></i></button></li>
					<li style={{ color: 'white' }}>versie: jan 2024</li>
				</ul>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {}
}

export default connect(mapStateToProps)(SideBarMenuBottom)


// WEBPACK FOOTER //
// ./src/application/templates/sidebarMenuBottom.js